module.exports = __webpack_public_path__ + "static/media/Dual_4651.c7c44c2c.jpg";